<template>
    <div id="app" style="background-color: #fff;">
        <Row class="wrapper">
            <Col :md="7" :sm="9" :xs="24" v-show="lrDisplay==0 || lrDisplay==-1">
                <panel-left
                        v-bind:user-info="userInfo"
                        v-bind:users-list="usersList"
                        v-bind:all-users-list="allUsersList"
                        v-bind:userIndex="userIndex"
                        @actionLeft = "actionLeft"
                        @allUserSelected = "allUserSelected"
                        @userSelected="userSelected">
                </panel-left>
            </Col>

            <transition name="slide-fade">
            <Col :md="17" :sm="15" :xs="24" v-show="lrDisplay==1 || lrDisplay==-1">
                <panel-main
                    v-bind:user="user"
                    v-bind:userInfo="userInfo"
                    @actionMain="actionMain"
                    @chexiaoMsg="chexiaoMsg"
                    @sendMsg="sendMsg">
                </panel-main>
            </Col>
            </transition>
            <!--Col span="5"><panel-right></panel-right></Col-->
        </Row>

        <Modal v-model="Object.keys(userInfo).length === 0" title="请登录" :closable="false" :mask-closable="false">
            <Form ref="formLogin" :model="formLogin" :rules="formLogin.rule" inline>
                <FormItem prop="user">
                    <Input type="text" v-model="formLogin.user" placeholder="Username">
                        <Icon type="ios-person-outline" slot="prepend"></Icon>
                    </Input>
                </FormItem>
                <FormItem prop="password">
                    <Input type="password" v-model="formLogin.password" placeholder="Password">
                        <Icon type="ios-lock-outline" slot="prepend"></Icon>
                    </Input>
                </FormItem>
            </Form>

            <div slot="footer">
                <Button size="large" @click="formLoginSubmit('formLogin')">登录</Button>
            </div>
        </Modal>

        <Modal v-model="formPasswd.show" title="密码修改" :closable="false">
            <Form ref="formPasswd" :model="formPasswd" :rules="formPasswd.rule" inline>
                <FormItem prop="passwd">
                    <Input type="password" v-model="formPasswd.passwd" placeholder="旧密码">
                        <Icon type="ios-lock-outline" slot="prepend"></Icon>
                    </Input>
                </FormItem>
                <FormItem prop="passwd2">
                    <Input type="password" v-model="formPasswd.passwd2" placeholder="新密码">
                        <Icon type="ios-lock-outline" slot="prepend"></Icon>
                    </Input>
                </FormItem>
            </Form>

            <div slot="footer">
                <Button size="large" @click="formLoginSubmit('formPasswd')">确定</Button>
            </div>
        </Modal>

        <Modal v-model="memberManage.show" title="人员管理">
            <Form ref="formUpdateUser" :model="formLogin" :rules="formLogin.rule" inline>
                <FormItem prop="user">
                    <Input type="text" size="default" v-model="formLogin.user" placeholder="Username" style="width: 200px;">
                        <Icon type="ios-person-outline" slot="prepend"></Icon>
                    </Input>
                </FormItem>
                <FormItem prop="password">
                    <Input type="password" size="default" v-model="formLogin.password" placeholder="Password" style="width: 190px;">
                        <Icon type="ios-lock-outline" slot="prepend"></Icon>
                    </Input>
                </FormItem>

                <FormItem>
                    <Button type="primary" size="default" @click="formLoginSubmit('formUpdateUser')">添加</Button>
                </FormItem>
            </Form>
            <Table size="small" :columns="memberManage.columns" :data="memberManage.data"></Table>
        </Modal>

        <Modal v-model="memberSearch.show" title="人员列表" @on-ok="memberSearchOk">
            <template>
                <Input v-if="!user.group" v-model="memberSearch.group_name" placeholder="群名称 创建后不可修改" style="margin-bottom: 8px;" />
            </template>
            <Table size="small" :columns="memberSearch.columns" :data="memberSearch.data" @on-selection-change="memberSearchSelected"></Table>
        </Modal>

        <Modal v-model="ws_status" :footer-hide="true" :closable="false" :mask-closable="false" width="320">
            <Spin></Spin><span style="color: #ff9900; float: left; margin: -26px 0 0 60px; font-size: 15px;">服务器连接中...</span>
        </Modal>
    </div>
</template>

<script>
import PanelLeft from './components/PanelLeft';
import PanelMain from './components/PanelMain';
import PanelRight from './components/PanelRight';
import wsEvents from './wsEvents';
require('./wsEvents.js');

export default {
    name: 'App',
    components: {
        PanelLeft,
        PanelMain,
        PanelRight,
    },

    methods: {
        userSelected: function(index){  //点击会员对话
          console.log('userSelected');
            if ( index < 0 || index > this.usersList.length ) {
                this.user = {};
                return;
            }
            this.user = this.usersList[index];

            // 消息
            // this.ws.send( JSON.stringify({'type': 'msg_list', 'group': this.user.group, 'from': this.user.name, 'to': this.userInfo.name}) );

            // if ( this.user.unread > 0 ) {
            //     this.ws.send( JSON.stringify({'type': 'mark_read', 'from': this.user.name, 'to': this.userInfo.name}) );
            // }

            // 获取消息 把消息设为读取过
            var params = new URLSearchParams()
                params.append('mtid', this.userInfo.data.id);
                params.append('uid', this.user.id);
                let urlHost = process.env.API_HOST // 会自动判断当前是开发还是生产环境，然后自动匹配API_HOST
                this.$axios.post(urlHost+'/index.php/api/Api_ws/GetUserMsg',params).then(res=>{
                  console.log(res);
                  console.log('获取消息');
                  let data = [];
                  res.data.data.forEach(item=>{

                         data.push( {
                              msg_id:item.id,
                              type: item.message_type==null?'txt':item.message_type, // img file
                              uid: item.uid , //未知
                              to: '2',
                              msg: item.message ,
                              name: item.type==1?item.username:item.realname ,
                              img: item.message_img,
                              filename:item.message_file,
                              time:item.crtime
                        })

                  })
                  this.user.content = data
                  console.log(this.user);

                })

            this.user.unread = 0;

            // 选中会话中的用户
            this.userIndex = index;
            if ( isPhone && index > -1 ) {
                // 手机版，需要显示聊天框
                this.lrDisplay = 1;
            }
        },

        allUserSelected: function(user) {
            // 在未读消息那里双向加好友了
            // this.ws.send(JSON.stringify({'type': 'add_friend', 'from': this.userInfo.name, 'to': user.name}));
          console.log('allUserSelected');
            // 从人员列表中选择聊天对象
            this.usersList.unshift({   // unshift 将数据添加到数组起始位置
                'name': user.name,
                'group': false,
                'unread': 0,
                'last_time': 9999999999,
                'content': []
            });
            this.user = this.usersList[0];  //

            this.userSelected(0);
        },

        formLoginSubmit(name) {  //提交验证
            this.$refs[name].validate((valid) => {
                if (valid) {
                    switch(name) {
                        case 'formLogin':
                        var params = new URLSearchParams()
                            params.append('name', this.formLogin.user)
                            params.append('password', this.formLogin.password)
                            // this.ws.send(JSON.stringify(data));
                              //发送get请求
                              console.log(process.env.API_HOST);
                              let urlHost = process.env.API_HOST // 会自动判断当前是开发还是生产环境，然后自动匹配API_HOST
                              this.$axios.post(urlHost+'/index.php/api/Api_ws/login',params).then(res=>{
                                  console.log(res.data);
                                  if ( res.data.error==0 ) {
                                      return this.$Message.error(res.data.msg);
                                  }
                                  let data = res.data
                                  this.$Message.success(data.msg);

                                  this.formLogin.user = '';
                                  this.formLogin.password = '';

                                  delete data.data.password
                                  this.userInfo = data;
                                  sessionStorage.setItem('user', JSON.stringify(data.data));

                              var senddata = {
                                    'type': 'bindadminid',
                                    'uid': data.data.id
                                  };
                                  this.ws.send(JSON.stringify(senddata));//绑定
                                  // this.afterLogin();  //获取对话列表
                                  //对话列表
                                  data.duihua_list.forEach(item=>{
                                    let user_list =  {
                                        'id':item.uid,
                                        'name': item.username,
                                        'img': '',
                                        'group': false,
                                        'unread': item.unread, //留言的次数
                                        'last_time': item.crtime,
                                        'content': []
                                      }
                                      this.usersList.push(user_list);
                                  })

                                  console.log( this.usersList);

                              })
                        break;

                        case 'formUpdateUser':
                            var data = {
                                'type': 'update_user',
                                'name': this.formLogin.user,
                                'passwd': this.formLogin.password
                            };
                            this.ws.send(JSON.stringify(data));
                        break;

                        case 'formPasswd':
                            var data = {
                                'type': 'passwd',
                                'passwd': this.formPasswd.passwd,
                                'passwd2': this.formPasswd.passwd2,
                                'name': this.userInfo.name
                            };
                            this.ws.send(JSON.stringify(data));
                        break;
                    }
                }
            })
        },

        wsUpdateUser($data){

        },

        wsMsg( evt ){
            let msg = eval('('+ evt.data +')');
            console.log(msg);
            switch ( msg.type ) {

                case 'friend_list':
                    for ( let i in msg.data ) {
                        msg.data[i].content = [];
                    }
                    this.usersList = msg.data;
                break;

                case 'msg_list':
                    this.user.content = msg.data;
                break;
                case 'ping':
                     console.log(msg);
                break;
                case 'del_message':
                  console.log('删除');
                  let msg_id = msg.msg_id
                  this.user.content.forEach((item,key)=>{
                    if( item.msg_id == msg_id ){
                        this.chexiaoMsg(key);//key 循环的key
                    }
                  })

                  break;
                case 'txt':
                case 'img':
                case 'file':
                    console.log('file');
                            // 用户消息
                            if ( msg.new_chat == 1 ) {
                                this.usersList.unshift({
                                    'id':msg.from,
                                    'name': msg.name,
                                    'img': '',
                                    'group': false,
                                    'unread': 1, //留言的次数
                                    'last_time': msg.time,
                                    'content': []
                                });
                                if ( typeof(this.user.name) != 'undefined' ) {
                                    this.userIndex += 1;
                                }
                            }else if ( msg.from != this.user.id ) {  //不在当前用户对话
                            console.log(this.usersList);
                                for ( let i in this.usersList ) {
                                    if ( this.usersList[i].id == msg.from ) {
                                        this.usersList[i].unread ++; //添加次数
                                        this.usersList[i].last_time = msg.time;

                                        let _top = this.usersList[i];
                                        this.usersList.splice(i, 1);//删掉
                                        this.usersList.unshift(_top); //置顶

                                        if ( this.userIndex >= 0 && this.userIndex < i ) {
                                            this.userIndex += 1;
                                        }
                                        break;
                                    }
                                }
                            } else {
                              console.log('添加学生消息');
                                this.user.last_time = msg.time;
                                this.user.content.push( msg );//添加消息
                                console.log(this.user);

                                //学生发送消息当前窗口为已读
                                var params = new URLSearchParams()
                                    params.append('uid', this.user.id)
                                    console.log(this.user);
                                    let urlHost = process.env.API_HOST // 会自动判断当前是开发还是生产环境，然后自动匹配API_HOST
                                 this.$axios.post(urlHost+'/index.php/api/Api_ws/upUreade',params).then(res=>{
                                   console.log('当前窗口接受的消息标识为已读');
                                 })
                            }

                break;

                default:
                console.log('function');
                    if ( typeof( wsEvents[msg.type] ) == 'function' ) {
                        wsEvents[msg.type]( this, msg );
                    }
                break;
            }

        },

        sendMsg (msg, ext) {
          console.log(msg);

              var params = new URLSearchParams()
                  params.append('mtid', this.userInfo.data.id)
                  params.append('touid', this.user.id)
                  params.append('msg', msg )
                  params.append('message_type', ext.type )
                  params.append('teacher_type', this.userInfo.data.teacher_type )
                   let urlHost = process.env.API_HOST // 会自动判断当前是开发还是生产环境，然后自动匹配API_HOST
           this.$axios.post(urlHost+'/index.php/api/Api_ws/SendUserMsg',params).then(res=>{
             console.log(res);
                   if(res.data.error){
                     let r = res.data
                     //老师发送消息
                      let data = {
                          'id': this.userInfo.data.id,
                          'type': ext.type,
                          'from': this.userInfo.data.id,
                          'to': this.user.id,
                          'uid':this.user.id,
                          'msg': msg,
                          'msg_id':r.data.instell_id,
                          'name': this.userInfo.data.username,
                          'time':new Date().toLocaleDateString()+ new Date().getHours() +' '+ new Date().getMinutes()+' '+ new Date().getSeconds(),//当前日期

                      };

                     data.time = r.time
                       this.user.content.push( data );//添加消息

                   }

           })
        },
        chexiaoMsg(key1){
          //删除信息
          console.log(key1);
          this.user.content.splice(key1,1);

        },
        actionLeft(act, data){
            switch ( act ) {
                case 'memberManage':
                    this.ws.send(JSON.stringify({'type': 'user_list'}));
                    this.memberManage.show = true;
                break;

                case 'passwd':
                    this.formPasswd.show = true;
                break;
            }
        },

        afterLogin(){
            // this.ws.send(JSON.stringify({'type': 'friend_list'})); //朋友列表

            // setTimeout(() => {
            //     this.ws.send(JSON.stringify({'type': 'user_list', 'online': 1})); //用户列表
            // }, 500);
        },

        connectWs(){
            let vthis = this;
            if ( this.wsStatus == -1 ) {
                this.ws = new WebSocket(wsUrl);
                this.ws.onopen = function() {
                    vthis.wsStatus = 10;
                    console.log('打开链接');
                };
                this.ws.onmessage = this.wsMsg;  //客户端接受服务端
                this.ws.onclose = function() {
                    console.debug('onclose...');
                    vthis.wsStatus = -1;
                };
            }

            setTimeout(this.connectWs, 3000);
        },

        actionMain(event, data) {
            switch ( event ) {
                case 'memberSearch':
                    this.ws.send(JSON.stringify({'type': 'user_list'}));
                    this.memberSearch.show = true;
                break;

                case 'delConversation':
                    if ( this.user.group ) {
                        this.ws.send(JSON.stringify({
                            'type': 'leave_group',
                            'from': this.userInfo.name,
                            'group_name': this.user.name
                        }));
                    } else {
                        this.ws.send(JSON.stringify({
                            'type': 'del_friend',
                            'from': this.userInfo.name,
                            'name': this.user.name
                        }));
                    }

                    this.usersList.splice(this.userIndex, 1);
                    this.userIndex = -1;
                break;

                case 'back':
                    this.lrDisplay = 0;
                    this.userIndex = -1;
                break;
            }
        },


        memberSearchSelected(selection) {
            this.memberSearch.selected = [];
            for ( var i in selection ) {
                this.memberSearch.selected.push(selection[i].name);
            }
        },

        memberSearchOk() {
            if ( this.memberSearch.selected.length == 0 ) return ;

            let group_name = '';
            let create = true;
            if ( this.user.group ) {
                group_name = this.user.name;
                create = false;
            } else {
                if ( this.memberSearch.group_name == '' ) {
                    this.$Message.error('请填写群名称!');
                    return;
                }

                this.memberSearch.selected.push(this.user.name);
                this.memberSearch.selected.push(this.userInfo.name);

                group_name = this.memberSearch.group_name; //this.memberSearch.selected.slice(0,2).join(',') + new Date().getTime();

                this.memberSearch.group_name = '';
            }

            let data = {
                'type': 'join_group',
                'create': create,
                'from': this.userInfo.name,
                'group_name': group_name,
                'users': this.memberSearch.selected
            };
            this.ws.send(JSON.stringify(data));
        },

    formloginfu(){
      var params = new URLSearchParams()
          params.append('name', this.formLogin.user)
          params.append('password', this.formLogin.password)
          // this.ws.send(JSON.stringify(data));
            //发送get请求
            console.log(process.env.API_HOST);
            let urlHost = process.env.API_HOST // 会自动判断当前是开发还是生产环境，然后自动匹配API_HOST
            this.$axios.post(urlHost+'/index.php/api/Api_ws/login',params).then(res=>{
                console.log(res.data);
                if ( res.data.error==0 ) {
                    return this.$Message.error(res.data.msg);
                }
                let data = res.data
                this.$Message.success(data.msg);

                this.formLogin.user = '';
                this.formLogin.password = '';

                delete data.data.password
                this.userInfo = data;
                sessionStorage.setItem('user', JSON.stringify(data.data));

            var senddata = {
                  'type': 'bindadminid',
                  'uid': data.data.id
                };
                this.ws.send(JSON.stringify(senddata));//绑定
                // this.afterLogin();  //获取对话列表
                //对话列表
                data.duihua_list.forEach(item=>{
                  let user_list =  {
                      'id':item.uid,
                      'name': item.username,
                      'img': '',
                      'group': false,
                      'unread': item.unread, //留言的次数
                      'last_time': item.crtime,
                      'content': []
                    }
                    this.usersList.push(user_list);
                })

                console.log( this.usersList);

            })
    },
    //jiewei
    },

    created () {
        let vthis = this;

        // 初始化界面，为手机时列表、聊天界面分开显示
        this.lrDisplay = isPhone ? 0 : -1;

        var user = sessionStorage.getItem('user');
        if ( user != null ) {
            this.userInfo = eval('('+ user +')');
        }

        //http://127.0.0.1:8080/#/chat?user=123&password=321  接收默认登录账号
        if(Object.keys(this.$route.query).length !== 0){
          var user=this.$route.query.user;
          var password=this.$route.query.password;
          this.formLogin.user = user;
          this.formLogin.password = password ;
          this.formloginfu();
        }

        console.log(this.$route.query);


        // wsStatus : -1 断开 0 - 9 连接中 10 连接上
        this.connectWs();

        /*
        if ( Object.keys(this.userInfo).length === 0 ) {
            this.$router.push("/login");
            return;
        }
        */

        setInterval(()=>{
            let m1 = '【新消息】';
            let m2 = '【　　　】';

            if ( this.notification.title == '' ) {
                this.notification.title = document.querySelector('title').innerHTML;
            }

            let unread = this.usersList.filter(u => u.unread > 0);

            if ( unread.length == 0 ) {
                document.querySelector('title').innerHTML = this.notification.title;
                return;
            }

            if ( this.notification.trigger ) {
                document.querySelector('title').innerHTML = m1 + ' - '+ this.notification.title;
                this.notification.trigger = false;
            } else {
                document.querySelector('title').innerHTML = m2 + ' - '+ this.notification.title;
                this.notification.trigger = true;
            }
        }, 500);
    },

    watch: {
    },

    computed: {
        ws_status: function () {
            return this.wsStatus != 10 ? true : false;
        }
    },

    data() {
        return {
            ws: '',
            wsStatus: -1,

            lrDisplay: -1, // 为手机时，列表、聊天界面分开显示；为：0、隐藏聊天界面，1、隐藏列表界面，-1、不处理

            formLogin: {
                user: '',
                password: '',

                rule: {
                    user : [
                        { required: true, message: '请填写用户名', trigger: 'blur' }
                    ],

                    password: [
                        { required: true, message: '请填写密码', trigger: 'blur' },
                        { type: 'string', min: 6, message: '密码最少6位', trigger: 'blur' }
                    ]
                }
            },

            formPasswd: {
                show: false,
                passwd: '',
                passwd2: '',

                rule: {
                    passwd : [
                        { required: true, message: '请填写旧密码', trigger: 'blur' },
                    ],

                    passwd2: [
                        { required: true, message: '请填写新密码', trigger: 'blur' },
                        { type: 'string', min: 6, message: '密码最少6位', trigger: 'blur' }
                    ]
                }
            },

            userInfo: {
				//当前用户
            },

            allUsersList:[],
            usersList: [

                // {
                //     id: 1,
                //     group: true,
                //     members: [
                //         {
                //             name: '前端群',
                //             img: '//tva4.sinaimg.cn/crop.0.1.1125.1125.180/475bb144jw8f9nwebnuhkj20v90vbwh9.jpg',
                //         }
                //     ],
                //     name: '小明',
                //     img: '//tva4.sinaimg.cn/crop.0.1.1125.1125.180/475bb144jw8f9nwebnuhkj20v90vbwh9.jpg',
                //     unread: 0,
                //     content: [
                //         {
                //             type: 'txt', // img file
                //             uid: 1,
                //             to: '2',
                //             msg: 'ssssss',
                //             name: '小明',
                //             img: '//tva4.sinaimg.cn/crop.0.1.1125.1125.180/475bb144jw8f9nwebnuhkj20v90vbwh9.jpg',
                //             time: 1234567890
                //         }
                //     ]
                // },

                // {
                //     id: 2,
                //     group: false,
                //     num: 0,
                //     name: '小李',
                //     img: '//tva1.sinaimg.cn/crop.0.0.118.118.180/5db11ff4gw1e77d3nqrv8j203b03cweg.jpg',
                //     unread: 3, //留言的话
                //     content: [
                //         {
                //             type: 'txt', // img file
                //             uid: 1,
                //             to: '2',
                //             msg: 'ssssss',
                //             name: '小明',
                //             img: '//tva4.sinaimg.cn/crop.0.1.1125.1125.180/475bb144jw8f9nwebnuhkj20v90vbwh9.jpg',
                //             time: 1234567890
                //         },

                //         {
                //             type: 'img', // img file
                //             uid: 2,
                //             to: '1',
                //             msg: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSdvjrryBoc_rdovfcwNgVuGRG8qqWA-BJ2Ti_TKc3wLzR_2mt',
                //             name: '小李',
                //             img: '//tva1.sinaimg.cn/crop.0.0.118.118.180/5db11ff4gw1e77d3nqrv8j203b03cweg.jpg',
                //             time: 1234567890,
                //         },

                //         {
                //             type: 'file', // img file
                //             uid: 2,
                //             to: '2',
                //             filename: '好文件',
                //             msg: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSdvjrryBoc_rdovfcwNgVuGRG8qqWA-BJ2Ti_TKc3wLzR_2mt',
                //             name: '小李',
                //             img: '//tva1.sinaimg.cn/crop.0.0.118.118.180/5db11ff4gw1e77d3nqrv8j203b03cweg.jpg',
                //             time: 1234567890,
                //             from:1
                //         },
                //     ]
                // }

            ],

            user: {},   //   this.user = this.usersList[index];
            userIndex: -1,  //用户下标数

            memberManage: {
                show: false,
                columns: [
                    {'title': '用户名', 'key': 'name'},
                    {'title': '操作', 'key': 'act',
                    render: (h, params) => {
                            return h('div', [
                                /*
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.ws.send( JSON.stringify({'type': 'update_user', 'name':params.row.name, 'del': 1}) );
                                        }
                                    }
                                }, '删除'),
                                */

                                h('Button', {
                                    style: {
                                        marginLeft: '5px'
                                    },
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {

                                            this.formLogin.user = params.row.name;
                                        }
                                    }
                                }, '密码修改'),
                            ]);
                        }
                    }
                ],
                data: [
                    {'name': 'loading...'}
                ]
            },

            memberSearch: {
                show: false,
                columns: [
                    {'type': 'selection', width: 80},
                    {'title': '用户名', 'key': 'name'}
                ],

                data: [{'name': 'loading...'}],

                group_name: '',
                selected: []
            },

            notification: {
                trigger: true,
                title: '',
            }
        }
    }
}
</script>

<style>
.wrapper, .wrapper>.ivu-col{ height: 100%;}
.wrapper { max-width: 1000px; margin: auto; border: #dcdee2 1px solid;}

/* 动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity .8s;
}
.fade-enter, .fade-leave-to .fade-leave-active {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(100px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue